<div class="modal-header">
  <h4 class="modal-title pull-left">Assign to Report</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <crm-alert #alert></crm-alert>
  <div class="row" id="SEARCH_APP">
    <div class="col-sm-12">
      <label class="rbv-label">Search Application</label>
      <input-search [provider]="reportProvider" [inputValue]="selectedReport" placeholder="Select Report to Assign"
        (valueChange)="onSelected($event)"></input-search>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv warning" [disabled]="!selectedReport" (click)="onConfirm()">Accept</button>
</div>
